import { Injectable } from '@angular/core';
import { AppConstants } from '../app-constants.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthKeycloakService } from './auth-keycloak.service';

export interface UploadStatus {
    total: number;
    loaded: number;
    filename: string;
}

// ODOT, könnte man noch umbauen/loswerden; nur noch für Uploads relevant
@Injectable()
export class RestService {

    protected path: string; // = '/api';

    constructor(
        protected readonly authKeycloakService: AuthKeycloakService,
        protected readonly http: HttpClient,
        protected readonly appConstants: AppConstants,
    ) {
        this.path = appConstants.restParentPath;
    }

    doFileUpload(uri: string, formData: FormData, csrfToken: string = null): Observable<UploadStatus> {
        const behaviourSubject: BehaviorSubject<UploadStatus> = new BehaviorSubject({
            total: 0,
            loaded: 0,
            filename: undefined
        });

        const observable: Observable<UploadStatus> = behaviourSubject.asObservable();
        const xhr = new XMLHttpRequest();

        xhr.upload.onprogress = (e) => {
            behaviourSubject.next({
                total: e.total,
                loaded: e.loaded,
                filename: undefined
            });
        };

        xhr.onload = () => {
            if (xhr.status > 201) { // Fehlerzustände dürften HTTP-Status > 201 haben
                behaviourSubject.error(xhr.status);
                return;
            }

            const filename = xhr.responseText;

            if (!filename) {
                console.warn('Kein Upload-Dateinamen erhalten');
            }

            behaviourSubject.next({
                total: undefined,
                loaded: undefined,
                filename
            });

            behaviourSubject.complete();
        };

        xhr.onerror = (e) => { // Ggf. ein Connection Reset
            behaviourSubject.error('Upload-HTTP-Request fehlgeschlagen');
        };

        xhr.open('POST', this.path + uri);

        if (csrfToken) {
            xhr.setRequestHeader('X-XSRF-TOKEN', csrfToken);
        }

        if (this.authKeycloakService.accessToken) {
            xhr.setRequestHeader('Authorization', this.createBearerTokenAuthHeader());
        }

        xhr.send(formData);

        return observable;
    }

    private createBearerTokenAuthHeader() {
        return 'Bearer ' + this.authKeycloakService.accessToken;
    }

}

